export default "__VITE_PUBLIC_ASSET__97b0bcf2__"